module.exports = "https://img.zhijierongxing.com/saas/img/dele_mark.7d780848.png";